const settings = {
    cssProperties: {
        // Viewport dimensions - Note, these are not defined in the CSS
        // so that "var(..., fallbackValue)" can be used for defaults
        // when javascript isn't running
        viewportWidth: '--viewport-width',
        viewportHeight: '--viewport-height',
    },

    containerSelector: '*[data-viewport-scaled]',

    // defaultParameters: {
    // },
};

// Tracks the scroll animations present on the page
const viewportScaledElements = [];

/** Class that supplies viewport dimensions to an element as CSS properties */
export default class ViewportScaledElement {
    /**
     * @constructor
     * @param {HTMLElement} container The container that contains the
     * scroll animation
     */
    constructor(container) {
        this.container = container;

        // Record this instance
        viewportScaledElements.push(this);

        // If this is the first element added to the page,
        // perform our general initialization
        if (viewportScaledElements.length === 1) {
            initializeViewportMonitoring();
        }
    }

    static init() {
        // Find elements with the expected class name
        const elements = document
            .querySelectorAll(settings.containerSelector);

        for (let i=0; i<elements.length; i++) {
            new ViewportScaledElement(elements[i]);
        }
    }

    /**
     * Signals that the viewport dimensions have changed -
     * can be overrided in derived classes that require these
     * notifications
     * @param {number} width
     * @param {number} height
     */
    setViewportDimensions(width, height) {
        // Update CSS properties
        this.container.style.setProperty(
            settings.cssProperties.viewportWidth,
            `${window.innerWidth}`,
        );

        this.container.style.setProperty(
            settings.cssProperties.viewportHeight,
            `${window.innerHeight}`,
        );
    }
}

/*
    Internal functions
*/

function initializeViewportMonitoring() {
    const resizeCallback = function() {
        viewportScaledElements.forEach((viewportScaledElement) => {
            viewportScaledElement.setViewportDimensions(
                window.innerWidth,
                window.innerHeight,
            );
        });
    };

    window.addEventListener('resize', resizeCallback);
    setTimeout(resizeCallback, 1);
}
